import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../components/loader/Loader";


const withRouter = (WrappedComponent) => {
  return function RouterComponent(props) {
    const navigate = useNavigate();
    const location = useLocation();

    const users = useSelector(state => state?.users?.data);
    const getdatajson = useSelector(state => state?.trackhrdata);
    const CategoryData = useSelector(state => state?.trackhrcategory || {});

    const activeCategoryDataArr = CategoryData?.activeCategoryDataArr;
    const CategoryDataArrary = CategoryData?.CategoryDataArr;

    const user = users ? users[Object.keys(users)[0]]?.[0] : null;
    const userid = user?.empid ?? null;

    const colors = getdatajson?.colors ?? {};
    const Apipathurl = getdatajson?.apipathurl ?? "";

  
    if (!userid) {
      return (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
          <Loader/>
        </div>
      );
    }

    return (
      <WrappedComponent
        {...props}
        username={user?.username}
        navigate={navigate}
        location={location}
        userid={userid}
        categorydataarr={CategoryDataArrary}
        colors={colors}
        Apipathurl={Apipathurl}
        activecategorydataarr={activeCategoryDataArr}
      />
    );
  };
};

export default withRouter;
